<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Preferred Provider Details
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <nb-card>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="col-md-4">
          <mat-label>Service</mat-label>
          <mat-select (selectionChange)="getSubServices(service)" [(ngModel)]="service">
            <mat-option *ngFor="let service of serviceList" value="{{service.VendorServiceTypeID}}">
              {{service.VendorServiceTypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-4">
          <mat-label>SubService</mat-label>
          <mat-select [(ngModel)]="subService" (selectionChange)="getProviders(subService)">
            <mat-option *ngFor="let subService of subServiceList"
              value="{{subService.VendorServiceToSubServiceMappingID}}">
              {{subService.VendorSubServiceTypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-4">
          <mat-select placeholder="Provider" [(ngModel)]="providerKey"
            (selectionChange)="getPhysicalAddress(providerKey)">
            <mat-option *ngFor="let provider of providerList" value="{{provider.providerKey}}">
              {{provider.providerName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field class="col-md-3">
          <mat-label>Location</mat-label>
          <mat-select placeholder="Location" [(ngModel)]="locationKey">
            <mat-option *ngFor="let location of locationList" value="{{location.addressKey}}">
              {{location.locationName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button class="btn btn-semi-round bgBlue col-md-3 ml-2" (click)="addPrefrredProvider()">Add Service
          Provider</button>
      </div>
      <div class="col-md-12">
        <div class="col-md-12 p-1">
          <div class="data-table-event-file mt-4">
            <table id="accordion" class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Provider Key</th>
                  <th scope="col">Service</th>
                  <th scope="col">Sub Service</th>
                  <th scope="col">Sort Priority</th>
                  <th scope="col">Refusal Required</th>
                  <th scope="col">Provider Name</th>
                  <th scope="col">Street (Physical Address)</th>
                  <th scope="col">City</th>
                  <th scope="col">State</th>
                  <th scope="col">Edit</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let preferredProvider of preferredProviderDetails">
                  <td scope="col">{{preferredProvider.providerKey}}</td>
                  <td scope="col">
                    <div *ngIf="preferredProvider.pspKey != currentPspKey">
                      {{preferredProvider.serviceName}}
                    </div>
                    <div *ngIf="editFlag && preferredProvider.pspKey == currentPspKey">
                      <mat-form-field>
                        <mat-label>Service</mat-label>
                        <select matNativeControl (change)="getSubServices(editService)" [(ngModel)]="editService">
                          <option *ngFor="let service of serviceList" value="{{service.VendorServiceTypeID}}">
                            {{service.VendorServiceTypeName}}
                          </option>
                        </select>
                      </mat-form-field>
                    </div>
                  </td>
                  <td scope="col">
                    <div *ngIf="preferredProvider.pspKey != currentPspKey">
                      {{preferredProvider.subServiceName}}
                    </div>
                    <div *ngIf="editFlag && preferredProvider.pspKey == currentPspKey">
                      <mat-form-field>
                        <mat-label>SubService</mat-label>
                        <select matNativeControl [(ngModel)]="editSubService">
                          <option *ngFor="let subService of subServiceList"
                            value="{{subService.VendorServiceToSubServiceMappingID}}">
                            {{subService.VendorSubServiceTypeName}}
                          </option>
                        </select>
                      </mat-form-field>
                    </div>
                  </td>
                  <td scope="col">
                    <div *ngIf="preferredProvider.pspKey != currentPspKey">
                      {{preferredProvider.sortPriority}}
                    </div>
                    <div *ngIf="editFlag && preferredProvider.pspKey == currentPspKey">
                      <mat-form-field>
                        <mat-label>Sort Priority</mat-label>
                        <input type="text" class="w-100" placeholder="Priority" matInput [(ngModel)]="sortPriority">
                      </mat-form-field>
                    </div>
                  </td>
                  <td scope="col">
                    <div *ngIf="preferredProvider.pspKey != currentPspKey">
                      {{preferredProvider.refusal}}
                    </div>
                    <div *ngIf="editFlag && preferredProvider.pspKey == currentPspKey">
                      <mat-form-field>
                        <mat-label>Refusal Required</mat-label>
                        <select matNativeControl [(ngModel)]="editRefusal">
                          <option value="YES">Yes</option>
                          <option value="NO">No</option>
                        </select>
                      </mat-form-field>
                    </div>
                  </td>
                  <td scope="col">{{preferredProvider.providerName}}</td>
                  <td scope="col">{{preferredProvider.address}}</td>
                  <td scope="col">{{preferredProvider.city}}</td>
                  <td scope="col">{{preferredProvider.state}}</td>
                  <td scope="col">
                    <div>
                      <span *ngIf="preferredProvider.pspKey != currentPspKey" title="Edit"
                        (click)="editPreferredProvider(preferredProvider)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </span>
                    </div>
                    <div *ngIf="editFlag && preferredProvider.pspKey == currentPspKey">
                      <span>
                        <a (click)="savePreferredProvider(preferredProvider.pspKey)">Save</a> &nbsp;
                        <a (click)="cancel()">Cancel</a>
                      </span>
                    </div>
                  </td>
                  <td scope="col"><span (click)="deletePreferredProvider(preferredProvider.pspKey)" title="Remove"><i
                        class="fa fa-trash-o" aria-hidden="true"></i></span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </nb-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>